import { doSearchStoreAction, loadGridColumnSettingStoreAction, loadSavedFilterStoreAction } from '../../../Generic/SearchPage/actions/searchPageActions';
import { ObjectTypes } from '../../../../utils/constants';
import { cylinderSearchActions as searchPageSliceActions } from '../slices/cylinderSearchSlice';
import cylinderApi from '../../../../services/api/CylinderApi';
import { getEndDateWithTime, getStartDateWithTime } from '../../../../utils/constants/datetime';
// import { getClientIdsScreenAccessByState } from '../../../../utils/screenPermission';
import { getUserTimezone } from '../../../../hooks/useAuth';

const getStateSliceForSearchPage = (state) => state.cylinderSearch;
export const loadGridColumnSettingStoreActionHandler = () => async (dispatch, getState) => loadGridColumnSettingStoreAction({
  dispatch,
  getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeGridColumns: ObjectTypes.CylinderSearchGrid
});

export const loadSavedFilterStoreActionHandler = () => async (dispatch, getState) => loadSavedFilterStoreAction({ dispatch, getState, searchPageSliceActions, getStateSliceForSearchPage, objectTypeForSaveUserFilter: ObjectTypes.CylinderSearchUserFilter });

export const doSearchStoreActionHandler = () => async (dispatch, getState) => {
  const state = getState();
  const timezone = getUserTimezone(state);
  const searchParamBuilder = (filter) => ({
    clientIDs: filter?.clientIDs ?? [],
    cylinderType: filter?.CylinderType?.id ?? null,
    cylinderStatus: filter?.Status?.id ?? null,
    orderNumber: filter?.OrderNumber ?? '',
    rentalAgreementNumber: filter?.RentalAgreementNumber ?? '',
    cylinderSubStatus: filter?.SubStatus?.id ?? null,
    requestor: filter?.Requestor?.id ?? '',
    reportAddressIDs: filter?.reportAddressIDs ?? [],
    daysOut: filter?.DaysOut ?? null,
    shippingDateFrom: filter?.ShippedDateFrom ? getStartDateWithTime(filter?.ShippedDateFrom, timezone).toISOString() : null,
    shippingDateTo: filter?.ShippedDateTo ? getEndDateWithTime(filter?.ShippedDateTo, timezone).toISOString() : null,
    functionality: filter?.functionality ?? 'Cylinder',
    scenarioIDs: filter?.scenarioIDs ?? [],
    returnDueDateFrom: filter?.ReturnDueDateFrom ? getStartDateWithTime(filter?.ReturnDueDateFrom, timezone).toISOString() : null,
    returnDueDateTo: filter?.ReturnDueDateTo ? getEndDateWithTime(filter?.ReturnDueDateTo, timezone).toISOString() : null,
  });

  await doSearchStoreAction({
    dispatch,
    getState,
    searchPageSliceActions,
    getStateSliceForSearchPage,
    searchParamBuilder,
    searchWithPaginationApi: cylinderApi.searchCylinder,
    postResultsProcessHandler: null
  });
};
